export const FETCH_REGULAR_BILLING_HISTORY_REQUEST = 'FETCH_REGULAR_BILLING_HISTORY_REQUEST'
export const FETCH_REGULAR_BILLING_HISTORY_SUCCESS = 'FETCH_REGULAR_BILLING_HISTORY_SUCCESS'
export const FETCH_REGULAR_BILLING_HISTORY_FAILED = 'FETCH_REGULAR_BILLING_HISTORY_FAILED'
export const FETCH_REGULAR_BILLING_INFO_REQUEST = 'FETCH_REGULAR_BILLING_INFO_REQUEST'
export const FETCH_REGULAR_BILLING_INFO_SUCCESS = 'FETCH_REGULAR_BILLING_INFO_SUCCESS'
export const FETCH_REGULAR_BILLING_INFO_FAILED = 'FETCH_REGULAR_BILLING_INFO_FAILED'
